export function initThankYouPage() {
    if ($('.id--15').length) {
        thankYouPageTextChanges()
        orderNumber()
    }
}

function thankYouPageTextChanges() {
    $('h1.order-summary-heading').html('Die Bestellung wurde <strong>erfolgreich abgeschickt!</strong>');
    $('.order-summary-item.total').text('Wir senden Ihnen die Zusammenfassung per E-Mail zu.');
    $('.order-summary-item.summary-thx').text('Vielen Dank für Ihre Bestellung.');
}

function orderNumber() {
    const orderNumber = $('[data-testid="orderNumber"]').first().text().trim()
    if (!orderNumber) return

    const tableOrderNumber = $(`
    <tr>
      <th>
        <span class="row-header-label">Bestellnummer</span>
      </th>
      <td>${orderNumber}</td>
    </tr>
  `)

    const table = $('.co-payment-method .recapitulation-table tbody')
    if (!table.length) return

    table.prepend(tableOrderNumber)
}
